import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vi-incomplete-information',
  templateUrl: './incomplete-information.component.html',
  styleUrls: ['./incomplete-information.component.scss']
})
export class IncompleteInformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
